module.exports = __webpack_public_path__ + "static/media/AB_K18_5.403720a0.jpg";